import { XStylesSettings } from '@shared/types/types';
import { CheckboxProps } from '../model/types';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

const Checkbox = (props: CheckboxProps) => {
  const {
    size = 'medium',
    isIndeterminate = false,
    isDisabled = false,
    isChecked = false,
    onChange,
    settings,
    'data-testid': testId,
  } = props;

  return (
    <input
      type="checkbox"
      checked={isChecked}
      onChange={() => onChange()}
      disabled={isDisabled}
      data-testid={testId}
      {...stylex.props([
        styles.base,
        styles[size],
        isChecked && styles.checked(size),
        isDisabled && styles.disabled(size, isChecked),
        isIndeterminate && styles.indeterminate(isDisabled, isChecked),
        settings as XStylesSettings,
      ])}
    />
  );
};

export default Checkbox;
